export default function removeURLSFromString(string) {
  let result = string || '';
  // Create a regular expression to match the URL.
  // eslint-disable-next-line no-useless-escape
  const regex = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()[\]{};:'".,<>?«»“”‘’]))/g; // eslint-disable-line max-len
  result = result.replace(regex, '');

  // Remove URLs without protocols or www for example: some-site.com
  const urlWithoutProtocolRegex = /([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}/gi;
  result = result.replace(urlWithoutProtocolRegex, '');

  return result;
}
